import React from 'react';
import styled from 'styled-components';
import { FormField, FormFieldLabel, FormFieldValue } from 'styles/common.styles';
import { theme } from 'styles/theme';

const InputShell = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  width: ${(p) => p.$width || 'auto'};
  flex: 0 0 auto;
`;

const SearchInput = styled(FormFieldValue)`
  width: 100%;
  padding-right: ${(p) => (p.$withSearch ? '26px' : undefined)};
`;

/** ??? ?? ????(���) ?? */
const InnerSearchBtn = styled.button`
  position: absolute;
  top: 50%;
  right: 4px;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 2px;
  background: transparent;
  color: ${theme.colors.text.secondary};
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  &:hover:not(:disabled) {
    color: ${theme.colors.primary};
    background: ${theme.colors.primaryLight || 'rgba(37, 99, 235, 0.08)'};
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

/**
 * Text field. showSearch puts a small magnifier icon inside the input for code lookup.
 */
const TextField = ({
  name,
  label,
  value = '',
  type = 'text',
  width,
  flex,
  labelWidth,
  fieldWidth,
  showColon = false,
  readonly = false,
  onChange,
  onKeyDown,
  onKeyUp,
  showSearch = false,
  onSearch,
  searchTitle = '?? ??',
  fieldProps = {},
}) => {
  const inputWidth = width || 'auto';

  return (
    <FormField flex={flex || '0 0 auto'} width={fieldWidth || 'auto'}>
      {label && (
        <FormFieldLabel width={labelWidth}>{showColon ? `${label}:` : label}</FormFieldLabel>
      )}
      {showSearch ? (
        <InputShell $width={inputWidth}>
          <SearchInput
            name={name}
            type={type}
            value={value}
            readOnly={readonly}
            onChange={readonly ? undefined : onChange}
            onKeyDown={onKeyDown}
            onKeyUp={onKeyUp}
            $withSearch
            width="100%"
            {...fieldProps}
          />
          <InnerSearchBtn
            type="button"
            title={searchTitle}
            aria-label={searchTitle}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              // ??? readonly?? ????(���)? ?? � ????? ? ??
              if (typeof onSearch === 'function') onSearch({ name, value });
            }}
          >
            {'\u00B7\u00B7\u00B7'}
          </InnerSearchBtn>
        </InputShell>
      ) : (
        <FormFieldValue
          name={name}
          type={type}
          value={value}
          readOnly={readonly}
          onChange={readonly ? undefined : onChange}
          onKeyDown={onKeyDown}
          onKeyUp={onKeyUp}
          width={inputWidth}
          {...fieldProps}
        />
      )}
    </FormField>
  );
};

export default TextField;
